<script setup>

import KdContainer from "./kdContainer.vue";

</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="185px">
      <el-form-item label="是否存在质量问题" prop="hasQualityProblem">
        <el-radio-group :disabled="disableForm" v-model="form.hasQualityProblem">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <div v-if="form.hasQualityProblem == 1">
        <el-form-item label="是否差缺根因分析材料" prop="hasReasonAnalystMaterial">
          <el-radio-group :disabled="receivedForm && receivedForm.hasReasonAnalystMaterial != undefined" v-model="form.hasReasonAnalystMaterial">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="form.hasReasonAnalystMaterial == 1">
          <el-form-item label="根因分析差缺材料" prop="deficiencyAnalyst">
            <el-input :disabled="disableForm" v-model="form.deficiencyAnalyst" type="textarea" placeholder="请输入根因分析差缺材料" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <el-form-item label="根因分析材料">
            <el-input :disabled="disableForm" v-model="form.reasonAnalystMaterial" placeholder="请输入根因分析材料" type="textarea" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <el-form-item>
            <file-upload-list v-if="disableForm" ref="fileUploadList" :fileList="form.replenishFile"></file-upload-list>
            <drag-upload
              v-else
              ref="uploadFile"
              :accessoryList.sync="form.replenishFile"
              :httpRequest="imAction"/>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item v-if="form.hasReasonAnalystMaterial == 0" label="根因分析" prop="reasonAnalyst">
            <el-input :disabled="disableForm" v-model="form.reasonAnalyst" type="textarea" placeholder="请输入根因分析" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <el-form-item>
            <file-upload-list v-if="disableForm" ref="fileUploadList" :fileList="form.file"></file-upload-list>
            <drag-upload
              v-else
              ref="uploadFile"
              :accessoryList.sync="form.file"
              :httpRequest="imAction"/>
          </el-form-item>
        </div>
      </div>
      <el-form-item>
        <el-button class="lang-but" type="primary" @click="auditPassBtClick">通过</el-button>
        <el-button class="lang-but" type="danger" @click="auditRejectBtClick">驳回</el-button>
      </el-form-item>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog width="600px !important" title="审核驳回" :visible.sync="dialogVisible">
        <el-form :model="form" :rules="rules" ref="rejectFormRef" label-width="85px">
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input v-model="form.rejectReason" type="textarea" placeholder="请输入驳回原因" :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()">提交</el-button>
            <el-button plain  @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>

<style scoped lang="scss">

</style>
<script>
import {baseURL} from "../../util/url";
import {requestSubmitAuditKD} from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

export default {
  name: "kdAccountUnitAnalystAudit",
  components: { KdAuditPassDialog },
  props: {
    disableForm:{
      type: Boolean,
      default: false
    },
    taskId:String,
    questionId:String,
    taskDefKey:String,
    receivedForm:{
      hasQualityProblem:{
        type: Number,
        default: undefined
      },
      hasReasonAnalystMaterial: {
        type: Number,
        default: undefined
      },
      reasonAnalystMaterial: {
        type: String,
        default: ""
      },
      deficiencyAnalyst: {
        type: String,
        default: ""
      },
      reasonAnalyst: {
        type: String,
        default: ""
      },
      replenishFile: Array,
      file:Array
    }
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token")
      },
      imAction: "/manage/staff/upload?fileType=auditResource",
      dialogVisible:false,
      auditPassDialogVisible: false,
      form:{
        hasReasonAnalystMaterial: 0,
        hasQualityProblem: 1,
        reasonAnalystMaterial: "",
        deficiencyAnalyst: "",
        reasonAnalyst: "",
        replenishFile: [],
        file:[],
        rejectReason: "",
        auditText: "",
      },
      rules: {
        hasQualityProblem: [
          {
            required: true, message: "是否存在质量问题不能为空", trigger: ["blur", "change"]
          }
        ],
        hasReasonAnalystMaterial: [
          {
            required: true, message: "是否差缺根因分析材料不能为空", trigger: ["blur", "change"]
          }
        ],
        deficiencyAnalyst: [
          {
            required: true, message: '根因分析差缺材料不能为空', trigger: ["blur", "change"]
          }
        ],
        reasonAnalyst: [
          {
            required: true, message: '根因分析不能为空', trigger: ["blur", "change"]
          }
        ],
        rejectReason: [
          {
            required: true, message: "驳回原因不能为空", trigger: ["blur", "change"]
          }
        ]
      }
    }
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    },
    'form.hasReasonAnalystMaterial'(newVal) {
      this.$nextTick(() => {
        this.$refs.formRef.clearValidate("deficiencyAnalyst")
        this.$refs.formRef.clearValidate('reasonAnalyst');
        this.form.reasonAnalyst = this.receivedForm.reasonAnalyst??"";
        this.form.deficiencyAnalyst = this.receivedForm.deficiencyAnalyst??""
      });
    }
  },
  methods: {
    auditPassBtClick() {
      this.$refs['formRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        this.auditPassDialogVisible = true;
      })
    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        approval: true,
        hasReasonAnalystMaterial:this.form.hasReasonAnalystMaterial,
        reasonAnalystMaterial:this.form.reasonAnalystMaterial,
        deficiencyAnalyst: this.form.deficiencyAnalyst,
        reasonAnalyst:this.form.reasonAnalyst
      }
      requestSubmitAuditKD(formData).then(res => {
        if(res.status == "0"){
          this.$DonMessage.success('审批通过!');
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      })
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      })
    },
    auditRejectSubmit(){
      this.$refs['rejectFormRef'].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        let formData = {
          nowTaskId:this.taskId,
          questionId:this.questionId,
          taskDefKey:this.taskDefKey,
          auditText: this.form.rejectReason,
          variables:{
            approval: false
          },
        }
        requestSubmitAuditKD(formData).then(res => {
          if(res.status == "0"){
            this.$DonMessage.success('驳回成功!');
            this.backRouterPath();
            this.dialogVisible = false;
          }else {
            this.$DonMessage.error(res.message);
          }
        })
      })
    }
  },
  mounted() {
    if(this.receivedForm){
      this.form.reasonAnalystMaterial = this.receivedForm.reasonAnalystMaterial??"";
      this.form.hasReasonAnalystMaterial = (this.receivedForm.hasReasonAnalystMaterial !=  undefined )?Number(this.receivedForm.hasReasonAnalystMaterial):0;
      this.form.hasQualityProblem = (this.receivedForm.hasQualityProblem !=  undefined )?Number(this.receivedForm.hasQualityProblem):1;
      this.form.reasonAnalyst = this.receivedForm.reasonAnalyst??"";
      this.form.deficiencyAnalyst = this.receivedForm.deficiencyAnalyst??""
    }
  }
}
</script>
